import type { SupportedRepubName } from '~/repub-config';

export type CategoryOrderingConfig = {
  end?: string[];
  start: string[];
};

// League name constants used across category ordering
const EFL_CHAMPIONSHIP = 'EFL Champ';
const EFL_LEAGUE_ONE = 'EFL L1';
const EFL_LEAGUE_TWO = 'EFL L2';
const EPL = 'EPL';
const US_MLS = 'US MLS';
const UCL = 'UCL';
const UEL = 'UEL';
const UECL = 'Europa Conference';
const SPFL = 'Scottish Premiership';
const SERIE_A = 'Serie A';
const LA_LIGA = 'La Liga';
const BUNDESLIGA = 'Bundesliga';
const LIGUE_1 = 'Ligue 1';
const EREDIVISIE = 'Dutch Eredivisie';
const PRIMEIRA_LIGA = 'Portuguese Primeira Liga';
const AUSTRIAN_BUNDESLIGA = 'Austrian Bundesliga';

export const CATEGORY_ORDERING_CONFIGS = {
  WS: {
    start: Array.from(
      new Set([
        EPL,
        UCL,
        UEL,
        EFL_CHAMPIONSHIP,
        EFL_LEAGUE_ONE,
        EFL_LEAGUE_TWO,
        SPFL,
        LA_LIGA,
        BUNDESLIGA,
        SERIE_A,
        LIGUE_1,
      ]),
    ),
  },
  US: {
    start: Array.from(new Set(['NFL', 'NBA', 'NCAAF', 'NCAAB', 'MLB', 'WNBA', 'NHL'])),
    end: Array.from(new Set([EPL, 'La Liga', BUNDESLIGA, SERIE_A, LIGUE_1, US_MLS, EFL_CHAMPIONSHIP])),
  },
  OC: {
    start: Array.from(
      new Set([
        EPL,
        UCL,
        UEL,
        EFL_CHAMPIONSHIP,
        EFL_LEAGUE_ONE,
        EFL_LEAGUE_TWO,
        SPFL,
        LA_LIGA,
        BUNDESLIGA,
        SERIE_A,
        LIGUE_1,
        'NFL',
        'NBA',
        'NCAAF',
        'NCAAB',
        'MLS',
        'MLB',
        'WNBA',
        'NHL',
      ]),
    ),
  },
  GZ: {
    start: Array.from(
      new Set([
        SERIE_A,
        EPL,
        BUNDESLIGA,
        LA_LIGA,
        LIGUE_1,
        UCL,
        UEL,
        UECL,
        EREDIVISIE,
        PRIMEIRA_LIGA,
        AUSTRIAN_BUNDESLIGA,
        'MLS',
        SPFL,
        EFL_CHAMPIONSHIP,
        EFL_LEAGUE_ONE,
        EFL_LEAGUE_TWO,
        'NBA',
        'WNBA',
        'NCAAM',
        'WNCAA',
        'NHL',
        'MLB',
        'NFL',
        'NCAAF',
      ]),
    ),
  },
} satisfies Record<SupportedRepubName, CategoryOrderingConfig>;
